import { useNotifications } from "@faire/retailer-visitor-shared/components/Header/HeaderNotifications/hooks/useNotifications";
import isUndefined from "lodash/isUndefined";
import { useMemo } from "react";

export const useHasUnreadNotification = () => {
  const { notifications } = useNotifications();
  const hasUnreadNotification = useMemo(
    () =>
      notifications?.some(({ first_viewed_at }) =>
        isUndefined(first_viewed_at)
      ) ?? false,
    [notifications]
  );

  return { hasUnreadNotification };
};
